import { IMerchDetailResponse, IMerchMutationForm } from 'services/merch/types';

export const merchQueryToForm = (
  merchQuery: IMerchDetailResponse
): IMerchMutationForm => {
  const { merchStatus, ...merch } = {
    ...merchQuery,
    EAN: merchQuery.ean,
    statusId: merchQuery.merchStatus,
    gallery: { images: merchQuery.images, pendingImages: [], deleteImages: [] },
    mainImageId:
      merchQuery.images.length > 0
        ? merchQuery.images.filter(image => image.isMain === true)[0].imageId
        : undefined,
  };

  return merch;
};
